/**
 * URL de login por portal VTI (U-Pasaporte), construida desde VITE_PORTAL_BASE.
 * Devuelve null si el portal no está configurado (en ese caso se usa el login
 * local en /login).
 */
export function portalLoginUrl(): string | null {
  const portalBase = (import.meta.env.VITE_PORTAL_BASE as string | undefined)?.trim();
  if (!portalBase) return null;
  const app = (import.meta.env.VITE_VTI_APP as string | undefined) || 'titulacion';
  const base = portalBase.endsWith('/') ? portalBase : `${portalBase}/`;
  return `${base}vti?app=${encodeURIComponent(app)}`;
}
